<template>
    <transition
        enter-class="opacity-0"
        enter-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
    >
        <Layout :show-background="true" v-show="ready"
                container-class="flex flex-col justify-center min-h-screen py-10 sm:min-h-0 bg-primary">
            <div v-if="ready" class="w-full max-w-sm px-8 mx-auto">
                <h1 class="mb-4 text-lg font-semibold leading-tight text-center text-highlight-100">
                    {{ _('account_unsubscribe') }}
                </h1>

                <div class="mb-6">
                    <h3 class="mb-2 text-center text-highlight-100">
                        Cancellation will be effective at the end of your current billing period on
                        <span class="font-bold">{{ subscription.valid_until | dateFormat }}</span>
                    </h3>
                </div>

                <div class="mb-6">
                    <h3 class="mb-2 text-center text-highlight-100">
                        Current Plan:
                    </h3>
                    <h3 class="mb-2 font-semibold text-center text-highlight-100">
                        {{ plan.name }} {{ price(plan) }} / {{ plan.period }}
                    </h3>
                </div>

                <div class="mb-8 text-center">
                    <h3 class="mb-2 text-center text-highlight-100">
                        Provider:
                    </h3>
                    <div
                        :style="{ backgroundColor: `${provider.hex_code}` }"
                        class="inline-block px-8 mx-auto rounded-lg shadow"
                    >
                        <img :src="provider.icon_url" :alt="provider.name" class="h-14">
                    </div>
                </div>

                <BaseButton
                    href="#"
                    @click.native="cancelSubscription(subscription.product_name, subscription.telco.msisdn)"
                >
                    {{ _('account_unsubscribe') }}
                </BaseButton>

                <div class="flex justify-center w-full mt-6">
                    <button
                        type="button"
                        class="font-bold text-center underline uppercase text-highlight-100"
                        @click="back"
                    >
                        Back
                    </button>
                </div>
            </div>
        </Layout>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import NProgress from 'nprogress'
import moment from 'moment'
import Layout from '@/components/Layout.vue'
import BaseButton from '@/components/Base/BaseButton.vue';

export default {
    components: {
        BaseButton,
        Layout,
    },
    filters: {
        dateFormat: (value) => moment(String(value)).format('MMM D YYYY'),
    },
    data() {
        return {
            ready: false,
            config: '',
        }
    },
    computed: {
        ...mapGetters({
            fetched: 'localisation/fetched',
            _: 'localisation/translate',
            params: 'settings/get',
            client: 'settings/getClient',
            authenticated: 'user/authenticated',
            provider: 'providers/selected',
            user: 'user/get',
            subscriptions: 'user/subscriptions',
            packs: 'packs/all',
            price: 'packs/price',
        }),
        subscription() {
            const subscriptions = this.subscriptions.filter(
                (subscription) => subscription.provider === this.provider.name.toLowerCase(),
            )

            return subscriptions.length > 0 ? subscriptions[0] : null
        },
        plan() {
            const externalId = this.subscription.product_name;
            const packs = Object.values(this.packs)

            for (let i = 0; i < packs.length; i += 1) {
                const plan = packs[i].plans.find((plan) => plan.external_id.toString() === externalId.toString());

                if (plan) {
                    return plan
                }
            }

            return null
        },
    },
    watch: {
        fetched: {
            immediate: true,
            deep: true,
            handler(fetched) {
                if (fetched) {
                    setTimeout(() => {
                        this.ready = true
                        NProgress.done()
                    }, 1000)
                }
            },
        },
    },
    created() {
        NProgress.start()
    },
    async mounted() {
        if (Object.keys(this.authenticated).length) {
            const { access_token } = this.authenticated
            this.$store.dispatch('user/get', access_token)
                .then(() => this.$store.dispatch('user/subscriptions', {
                    key: this.params.api_key,
                    userId: this.user.id,
                }))
        } else if (Object.keys(this.$route.query).includes('access_token')) {
            this.$store.dispatch('user/get', this.$route.query.access_token)
                .then(() => this.$store.dispatch('user/subscriptions', {
                    key: this.params.api_key,
                    userId: this.user.id,
                }))
        } else {
            this.$router.push({ name: 'Login' })
        }

        this.config = await import(`@/resources/${this.client}`)
    },
    methods: {
        async cancelSubscription(subscriptionId, msisdn) {
            await this.$store.dispatch('charge/cancel', {
                msisdn,
                subscriptionId,
            })
                .then(() => {
                    this.$router.push({ name: 'Account' })
                })
        },
        back() {
            return this.$router.push({ name: 'Account' })
        },
    },
}
</script>
